import usePortal from 'react-cool-portal';
import SlideAndFadeTransition from '@stripcash/ui-kit/components/Motion/SlideAndFadeTransition';
import { AnimatePresence } from 'motion/react';

import { Notification } from 'types/notification';

import TranslatedNotification from './components/TranslatedNotification';

const portalOptions = {
  clickOutsideToHide: false,
  escToHide: false,
  autoRemoveContainer: false,
  containerId: 'notifications',
  defaultShow: true,
};

const SystemNotifications = ({
  notifications = [],
  onHide,
}: {
  notifications: Notification[];
  onHide: (data: { id: string }) => void;
}) => {
  const { Portal } = usePortal(portalOptions);

  return (
    <Portal>
      <AnimatePresence presenceAffectsLayout>
        {notifications.map((item) => (
          <SlideAndFadeTransition key={item.id}>
            <TranslatedNotification {...item} onHide={onHide} />
          </SlideAndFadeTransition>
        ))}
      </AnimatePresence>
    </Portal>
  );
};

export default SystemNotifications;
